
import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { takeUntil } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { PublicationsService } from 'src/app/Service/publications.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss']
})
export class ArchiveComponent implements OnInit {

  constructor(private service:PublicationsService, private global:Global,private translate:TranslateService) { }
articles = [];
pagination  = 5 ;
pageIndex = 1 ;
categories = [];
arrayDatePub = [];
selectedDate = '';
selectedCategorie = '';
search = '';
filtred = false;
dataShow = []; 
dataFiltred =[];
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => { 
      this.categories = [];
    


      forkJoin([this.service.getPress(lg.url), this.service.getAllPress(lg.url), this.service.getActualite(lg.url), this.service.getAllActualites(lg.url)]).subscribe(datas => {
        const alaUnePressArticleIds = []
        const alaUneActuArticleIds= [];
        this.categories.push(this.translate.instant("general.communiquespresse"));
        this.categories.push(this.translate.instant("general.Actualites"));
        this.articles = [];
       datas[2]['value'].forEach(element => {
         alaUnePressArticleIds.push(element.Id);
       });
       datas[0]['value'].forEach(element => {
         alaUneActuArticleIds.push(element.Id);
       });
       // Actualite
       datas[3]['value'].forEach(element => {
         if(alaUnePressArticleIds.indexOf(element.Id) === -1 && element.AcualiteDate !== null && element.AcualiteDate !== '' ) {
           const obj  = {
             Id: element.Id, 
             Title : element.Title,
             Description: element.ActualiteDescription, 
             DescriptionShow: this.titleDescription(element.ActualiteDescription, 400),
             TitleShow : this.titleDescription(element.Title, 100),
             PressDate : new Date(element.AcualiteDate),
             dateShow : this.formateDate( new Date(element.AcualiteDate)),
             currentDatePub : element.AcualiteDate ? this.getDateMonthFormat(new Date(element.AcualiteDate)) : '',
             url : '/publications/archive/' + element.Id, 
             Type: this.translate.instant('general.Actualites'), 
             Code: 'A'

           }
           this.articles.push(obj);
         }
       });
       // Communiqué de Press
       datas[1]['value'].forEach(element => {
        if(alaUnePressArticleIds.indexOf(element.Id) === -1  && element.PressDate !== null && element.PressDate !== '') {
          const obj  = {
            Id: element.Id, 
            Title : element.Title,
            Description: element.PressDescription, 
            DescriptionShow: this.titleDescription(element.PressDescription, 400),
            TitleShow : this.titleDescription(element.Title, 400),
            PressDate : new Date(element.PressDate),
            dateShow : this.formateDate( new Date(element.PressDate)),
            currentDatePub : element.PressDate ? this.getDateMonthFormat(new Date(element.PressDate)) : '',
            fichierLink : element.FileRef,
            Type: this.translate.instant('general.communiquespresse'), 
             Code: 'C'
          }
          this.articles.push(obj);
        }
      });
        this.articles = this.articles.sort((a,b) => {
          return b.PressDate - a.PressDate;
        });
        const dates = [];
        this.arrayDatePub = [];
      this.articles.forEach( article => {
        if(dates.indexOf(article.currentDatePub) === -1) {
          dates.push(article.currentDatePub); 
          this.arrayDatePub.push({
            date : article.currentDatePub,
            occurence : 1
          });
        } else {
          this.arrayDatePub[dates.indexOf(article.currentDatePub)]['occurence'] =  this.arrayDatePub[dates.indexOf(article.currentDatePub)]['occurence'] + 1 ;
        }
      });
      this.dataShow = this.articles.slice(0, this.pagination)
      });
    });
  }
  titleDescription(field, length) {
    
    if(field !== null && field !== undefined && field.length > length ) {
      return field.toString().replace(/<[^>]*>/g, '').substring(0,length) + '...'
    } else {
      return field ? field.replace(/<[^>]*>/g, '') : ''
    }
}
getDateMonthFormat(date:Date) {
  const  month = this.translate.instant('StatistiquesMois.' + (date.getMonth() + 1));
  return month + ' ' + date.getFullYear(); 
}
formateDate(date:Date) {
  return (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +'/' +  ((date.getMonth()+ 1 ) < 10 ? '0' + (date.getMonth()+ 1 ) : (date.getMonth()+ 1 ))  + '/' + date.getFullYear();
}
filterData() {
   if((this.search === '' || this.search === null) && this.selectedDate === '' &&  this.selectedCategorie === '') {
     this.filtred = false;
     this.pageIndex = 1; 
     this.dataShow = this.articles.slice(0, this.pagination);
   } else {
     this.filtred = true; 
     if(this.search !== null) {
       
     }
     if(this.search !== null) {
      this.dataFiltred = _.filter(this.articles, item=> (item.Title !== null && (item.Title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)) && (item.Description !== null || (item.Description.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)));
     } else {
       this.dataFiltred = this.articles;
     } 
     if(this.selectedCategorie !== '') {
      this.dataFiltred = _.filter(this.dataFiltred , item => item.Type === this.selectedCategorie)
     }
     if(this.selectedDate !== '') {
      this.dataFiltred = _.filter(this.dataFiltred , item => item.currentDatePub === this.selectedDate)
     }
     this.pageIndex= 1
     this.dataShow = _.slice(this.dataFiltred, 0, this.pagination);
    
   } 
}
ChargerPlus(){
  this.pageIndex++;
  if(this.filtred) {
    this.dataShow = _.slice(this.dataFiltred, 0, this.pagination * this.pageIndex);
  } else {
    this.dataShow = _.slice(this.articles, 0, this.pagination * this.pageIndex);
  }
}

}
